import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: () => import('@/pages/CardListPage.vue'),
    },
    {
      path: '/tiers',
      component: () => import('@/pages/TierMakerPage.vue'),
    },
    {
      path: '/boards',
      component: () => import('@/pages/BoardsPage.vue'),
    },
    {
      path: '/cards/:id',
      component: () => import('@/pages/CardListPage.vue'),
    },
  ],
})

export default router
